import { isApproval } from '../../../helpers/matchers'

export const buttonCopy = (phaseType) => {
  if (isApproval(phaseType)) {
    return 'Add an Approver'
  }
  return 'Add a Task'
}

const capitalize = (str) => (isApproval(str) ? 'Approval' : 'Task')

export const popoverCopy = (phaseType) =>
  `${capitalize(
    phaseType
  )}s cannot be added to this phase because it is locked.`

export const popoverOptions = {
  showOn: 'trigger.mouseenter',
  hideOn: 'trigger.mouseleave',
  bodyAttached: true,
  unnecessaryRepositioning: true,
  constraints: [
    { popover: 'top left', attachment: 'bottom center' },
    { popover: 'top center', attachment: 'bottom center' },
  ],
}

export const shouldDisableAdd = (disabled, otherProps) =>
  disabled ||
  otherProps.locked ||
  (isApproval(otherProps.phase_type) && otherProps.is_active)
